export enum ActionTypes {
  Identify = 'Identify',
  ApplyForCreditLine = 'ApplyForCreditLine',
  getApplicationDetails = 'getApplicationDetails',
  getExistingPaymentMethods = 'getExistingPaymentMethods',
  SettingAddress = 'SettingAddress',
}
